import React from "react";

const Grupo1 = ({datos, handleChange, eliminarFila}) => {

    return (

        <div>

            {/* ==========================
                TABLA
            ========================== */}

            <div className="table-responsive">

                <table className="table align-middle">

                    <thead className="table-secondary">

                        <tr>

                            <th style={{width:"35%"}}>PCB</th>
                            <th>Dato referencia</th>
                            <th>Dato mes</th>
                            <th>% Avance</th>
                            <th style={{width:"70px"}}>Acción</th>

                        </tr>

                    </thead>

                    <tbody>

                        {

                            datos.map((item,index)=>(

                                <tr key={index}>

                                    <td>

                                        <input
                                            className="form-control"
                                            value={item.pcb || ""}
                                            onChange={(e)=>
                                                handleChange(
                                                    index,
                                                    "pcb",
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </td>

                                    <td>

                                       <input
                                            type="number"
                                            className="form-control"
                                            min="0"
                                            step="1"
                                            value={item.dato_referencia ?? ""}
                                            onChange={(e) =>
                                                handleChange(
                                                    index,
                                                    "dato_referencia",
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </td>

                                    <td>

                                        <input
                                            type="number"
                                            className="form-control"
                                            min="0"
                                            step="1"
                                            value={item.dato_mes ?? ""}
                                            onChange={(e) =>
                                                handleChange(
                                                    index,
                                                    "dato_mes",
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </td>

                                    <td>

                                       <input
                                            className="form-control"
                                            value={`${item.porcentaje_avance ?? 0}%`}
                                            readOnly
                                        />

                                    </td>

                                    <td className="text-center">

                                        <button className="btn btn-sm btn-danger" onClick={()=>eliminarFila(index)}>
                                            <i className="bi bi-trash"></i>
                                        </button>

                                    </td>

                                </tr>

                            ))

                        }

                        {

                            datos.length===0 &&

                            <tr>

                                <td colSpan={5} className="text-center">
                                    No hay registros. Presione "Agregar fila" para comenzar.
                                </td>

                            </tr>

                        }

                    </tbody>

                </table>

            </div>

        </div>

    );

};

export default Grupo1;